import {
  Grid2 as Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  ManageSearch as ManageSearchIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { EmptyList, LoadingList } from "@/organism";
import { SubscriptionProductDto } from "@/dto/SubscriptionDto";

interface ListProps {
  list: SubscriptionProductDto[];
  onDetail?: (subscriptionId: number) => void;
  isLoading: boolean;
}

export const SubscriptionList = ({ list, onDetail, isLoading }: ListProps) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <LoadingList />
        </Box>
      );
    }

    if (list.length === 0) {
      return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <EmptyList />
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        {list.map((subscription: SubscriptionProductDto) => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={subscription.productId}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h5" component="div">
                    {subscription.productNm}
                  </Typography>
                  <Chip
                    label={subscription.activeYn === "Y" ? "활성" : "비활성"}
                    color={
                      subscription.activeYn === "Y" ? "success" : "default"
                    }
                    size="small"
                  />
                </Box>

                <Typography color="text.secondary" gutterBottom>
                  {subscription.productType}
                </Typography>

                <Box mt={2} mb={2}>
                  <Typography variant="h6" color="primary">
                    {subscription.currency}{" "}
                    {Number(subscription.monthlyAmt).toLocaleString()}/월
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    연간 {Number(subscription.firstYearAmt).toLocaleString()}{" "}
                    {subscription.currency}
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary" gutterBottom>
                  선납 기간: {subscription.prepaidPeriod}개월
                </Typography>

                <Typography variant="body2" sx={{ mt: 2 }}>
                  <List dense>
                    {subscription.productDtl.split("|").map((item, index) => (
                      <ListItem key={index} sx={{ py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <CheckCircleIcon color="success" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </Typography>
              </CardContent>

              <CardActions>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<ManageSearchIcon />}
                  onClick={() => onDetail?.(Number(subscription.productId))}
                >
                  상세보기
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  };

  return renderContent();
};
